import { Component, OnDestroy, OnInit, Input } from '@angular/core';

import { WidgetComponent } from '../core/widget.component';
import { ReportsService } from '../../../@apiClient/extensions';

@Component({
    selector: 'ngx-downloadreport',
    styleUrls: ['./downloadreport.component.scss'],
    templateUrl: './downloadreport.component.html',
})
export class DownloadReportWidgetComponent extends WidgetComponent implements OnInit, OnDestroy {

    constructor(reportsService: ReportsService) {
        super(reportsService);

    }

    @Input() title = '';
    projectGuid: string = '';
    projectGuids: any = {};
    region: string = '';
    regions: any = [];
    existsAvaiableParameters: boolean = false;
    dataexist: boolean = false;
    entityLoaded: boolean = false;
    existRegions: boolean = false;
    @Input() data;
    date: {
        begin: Date | null;
        end: Date | null;
    } = { begin: null, end: null }
    dateRange : Date[] = null;
    generatingInProgress: boolean = false;
    existsDistrict: boolean = false;
    existsArea: boolean = false;
    area: string = null;
    district: string = null;

    locations: any[];
    selectedLocation:any = null;

    ngOnInit() {
    }
    applyParameters() {
        this.parameters = {};
        if (this.projectGuid) {
            this.parameters.project_guid = this.projectGuid
        }
        if (this.date && this.date.begin && this.date.end) {
            this.parameters.dateBegin = this.date.begin.toISOString()
            this.parameters.dateEnd = this.date.end.toISOString()
        }
        if (this.selectedLocation){
            switch(this.selectedLocation.kind){
                case 'region':
                    this.parameters.region = this.selectedLocation.value;
                break;

                case 'district':
                    this.parameters.region = this.selectedLocation.region;
                    this.parameters.districtid = this.selectedLocation.value;
                break;

                case 'area':
                    this.parameters.region = this.selectedLocation.region;
                    this.parameters.districtid = this.selectedLocation.district;
                    this.parameters.areaid = this.selectedLocation.value;
                break;

            }
        }
        
        this.reloadAndRedraw();
    }
    getGuidFromTur() {
        if (this.availableParameters.length && this.availableParameters.length > 0) {
            this.existsAvaiableParameters = true
            this.projectGuids = this.availableParameters.find(x => x.variables == "project_guid")
            if (this.availableParameters.find(x => x.variables == "region")) {
                this.existRegions = true
                this.regions = this.availableParameters.find(x => x.variables == "region")
                var districts = [
                    { label: "Cały region Grudziądz", value: "00", areas: [{label: "Region Grudziądz", kind: 'region', value: "Grudziądz"}] },
                    { label: "30 Olsztyn", value: "30", areas: [
                        {label: "Okręg 30", value: "30", kind: 'district', region:'Grudziądz'},
                        {label: "301 Olsztyn I", value: "301", kind: 'area', district:'30', region:'Grudziądz'},
                        {label: "302 Olsztyn II", value: "302", kind: 'area', district:'30', region:'Grudziądz'},
                        {label: "303 Ostróda", value: "303", kind: 'area', district:'30', region:'Grudziądz'},
                        {label: "304 Iława", value: "304", kind: 'area', district:'30', region:'Grudziądz'},
                        {label: "305 Bartoszyce", value: "305", kind: 'area', district:'30', region:'Grudziądz'},
                        {label: "306 Morąg", value: "306", kind: 'area', district:'30', region:'Grudziądz'},
                        {label: "307 Brodnica", value: "307", kind: 'area', district:'30', region:'Grudziądz'} ]
                    },
                    { label: "31 Grudziądz", value: "31", areas: [ 
                        {label: "Okręg 31", value: "31", kind: 'district', region:'Grudziądz'},
                        {label: "311 Malbork", value: "311", kind: 'area', district:'31', region:'Grudziądz'},
                        {label: "312 Chojnice", value: "312", kind: 'area', district:'31', region:'Grudziądz'},
                        {label: "313 Starogard Gdański", value: "313", kind: 'area', district:'31', region:'Grudziądz'},
                        {label: "314 Grudziądz I", value: "314", kind: 'area', district:'31', region:'Grudziądz'},
                        {label: "315 Świecie", value: "315", kind: 'area', district:'31', region:'Grudziądz'},
                        {label: "316 Grudziądz II", value: "316", kind: 'area', district:'31', region:'Grudziądz'}]
                    },
                    { label: "32 Bydgoszcz", value: "32", areas: [
                        {label: "Okręg 32", value: "32", kind: 'district', region:'Grudziądz'},
                        {label: "321 Bydgoszcz I", value: "321", kind: 'area', district:'32', region:'Grudziądz'},
                        {label: "322 Bydgoszcz II", value: "322", kind: 'area', district:'32', region:'Grudziądz'},
                        {label: "323 Bydgoszcz III", value: "323", kind: 'area', district:'32', region:'Grudziądz'},
                        {label: "324 Bydgoszcz IV", value: "324", kind: 'area', district:'32', region:'Grudziądz'},
                        {label: "325 Nakło nad Notecią", value: "325", kind: 'area', district:'32', region:'Grudziądz'},
                        {label: "326 Inowrocław", value: "326", kind: 'area', district:'32', region:'Grudziądz'}]
                    },
                    { label: "33 Toruń", value: "33", areas: [
                        {label: "Okręg 33", value: "33", kind: 'district', region:'Grudziądz'},
                        {label: "331 Rypin", value: "331", kind: 'area', district:'33', region:'Grudziądz'},
                        {label: "332 Toruń I", value: "332", kind: 'area', district:'33', region:'Grudziądz'},
                        {label: "333 Toruń II", value: "333", kind: 'area', district:'33', region:'Grudziądz'},
                        {label: "334 Toruń III", value: "334", kind: 'area', district:'33', region:'Grudziądz'},
                        {label: "335 Włocławek I", value: "335", kind: 'area', district:'33', region:'Grudziądz'},
                        {label: "336 Włocławek II", value: "336", kind: 'area', district:'33', region:'Grudziądz'}] },
                ];
                this.locations = this.regions.values.map( x => {
                    x.districts = districts;
                    return x;
                });
            }
            else {
                this.existRegions = false
            }
        }
        else {
            this.existsAvaiableParameters = false
        }
    }
    existsDistrictParam() {
        if (this.existsAvaiableParameters && this.availableParameters.find(x => x.variables == "districtid")) {
            this.existsDistrict = true;
        }
    }
    existsAreaParam() {
        if (this.existsAvaiableParameters && this.availableParameters.find(x => x.variables == "areaid")) {
            this.existsArea = true;
        }
    }
    public reloadAndRedraw() {
        this.entityLoaded = false;
        if (this.parameters.project_guid) {
            this.projectGuid = this.parameters.project_guid
        }
        if (this.parameters.region) {
            this.region = this.parameters.region
        }
        if (this.parameters.dateBegin && this.parameters.dateEnd) {
            this.date.begin = new Date(this.parameters.dateBegin)
            this.date.end = new Date(this.parameters.dateEnd)
        }
        if (this.parameters.areaid) {
            this.area = this.parameters.areaid
        }
        if (this.parameters.districtid) {
            this.district = this.parameters.districtid
        }
        if (this.projectGuid) {
            this.parameters.project_guid = this.projectGuid
        }
        if (this.region) {
            this.parameters.region = this.region
        }
        if (this.date && this.date.begin && this.date.end) {
            this.parameters.dateBegin = this.date.begin.toISOString()
            this.parameters.dateEnd = this.date.end.toISOString()
        }
        if (this.area) {
            this.parameters.areaid = this.area
        }
        if (this.district) {
            this.parameters.districtid = this.district
        }
        if (this.date && this.date.begin && this.date.end) {
            this.dateRange = [this.date.begin, this.date.end];
            this.parameters.dateBegin = this.date.begin.toISOString()
            const dateEnd = new Date(this.date.end.getTime());
            dateEnd.setHours(dateEnd.getHours() + 24);
            this.parameters.dateEnd = dateEnd.toISOString()
        }
        
        this.loadData().then(() => {
            if (this.data && this.data.length > 0) {
                this.dataexist = true
                this.getGuidFromTur();
                this.existsDistrictParam();
                this.existsAreaParam();
                this.drawChart();
            }
            else {
                this.dataexist = false
                this.entityLoaded = true;
            }
        });
        if (this.date && this.date.begin && this.date.end) {
            this.parameters.dateEnd = this.date.end.toISOString();
        }
    }
    refreshAndRedraw() {
        this.projectGuid = null;
        this.region = null;
        this.date = {
            begin: null,
            end: null,
        };
        this.area = null;
        this.district = null;
        this.parameters = {};
        this.reloadAndRedraw();
    }
    drawChart() {

        setTimeout(() => {
            this.entityLoaded = true;
        });

    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
    }
    download() {
        this.generatingInProgress = true;
        //dodaję dzien do daty koncowej - zeby złapał cały dzień w wynikach
        if (this.date && this.date.end) {
            this.date.end.setHours(this.date.end.getHours() + 24);
        }
        this.applyParameters();
        //odejmuję dzien godzinę do daty końcowej - żeby na froncie nadal było ok
        if (this.date && this.date.end) {
            this.date.end.setHours(this.date.end.getHours() - 24);
        }
        let templateName = this.data[0].template;

        this.reportsService.getComplexReportAsXLSX(templateName, this.parameters).subscribe(res => {
            let dataType = res.type;
            let data = [res];
            let filename = "report.xlsx";
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(new Blob(data, { type: dataType }));
            downloadLink.setAttribute('download', filename);
            downloadLink.setAttribute('style', 'display:none;');
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.parentNode.removeChild(downloadLink);
            this.generatingInProgress = false;
        });
    }
}
